/**
 * フォームの情報
 */

const headList: any[] = [
  {
    headTitle: "施設名",
  },
  {
    headTitle: "職員名",
  },
  {
    headTitle: "生年月日",
  },
  {
    headTitle: "性別",
  },
  {
    headTitle: "加入年月日",
  },
];

export { headList };
